import {
  AnagraficaApplicazione,
  EnumAnagraficaApplicazioneProtocollazionePrincipale as ClientConfigPrincipalProtocol,
} from '@framework/api-client';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { shallowEqual, useSelector } from 'react-redux';

export interface ClientConfigState {
  applicationConfig?: AnagraficaApplicazione;
  /** Nome dell'applicazione (visibile) */
  displayName?: string | null;
  /** Protocollo principale RICHIESTA | DOCUMENTO, per il backoffice. */
  principalProtocol?: ClientConfigPrincipalProtocol | null;
}

export { ClientConfigPrincipalProtocol };

export interface IRootClientConfigState {
  clientConfig: ClientConfigState;
}

/**
 * Gestiamo la configurazione (AnagraficaApplicazione) del client.
 * Il tutto è gestito in `Auth` perché è necessario essere autenticati per
 * poter accedere a queste informazioni.
 */
export const ClientConfigSlice = createSlice({
  name: 'clientConfig',
  initialState: () => ({} as ClientConfigState),
  reducers: {
    setClientConfig: (state, action: PayloadAction<AnagraficaApplicazione>) => {
      return {
        ...state,
        applicationConfig: action.payload,
        displayName: action.payload.denominazione,
        principalProtocol: action.payload.protocollazionePrincipale,
      };
    },
  },
});

export const ClientConfigActions = ClientConfigSlice.actions;

/**
 * Ottiene la configurazione dell'applicazione.
 */
export const useClientConfig = () =>
  useSelector(
    (state: IRootClientConfigState) => state.clientConfig ?? {},
    shallowEqual,
  );
